import { render, staticRenderFns } from "./RecordEventsEdit.vue?vue&type=template&id=38b2e025"
import script from "./RecordEventsEdit.js?vue&type=script&lang=js&external"
export * from "./RecordEventsEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports